
import { defineComponent, ref } from 'vue';
import AppHeader from '@/components/AppHeader.vue';
// eslint-disable-next-line import/no-cycle
import { useGeneralStore } from '@/store/generalStore';
// eslint-disable-next-line import/no-cycle
import { useMainStore } from '@/store/mainStore';
import AppButton from '@/components/UI/AppButton.vue';
import AppInput from '@/components/UI/AppInput.vue';
import NotificationService from '@/services/NotificationService';
// eslint-disable-next-line import/no-cycle
import JourneyService from '@/services/JourneyService';
import AppVoiceToText from '@/components/AppVoiceToText.vue';

export default defineComponent({
  components: {
    AppHeader,
    AppButton,
    AppInput,
    AppVoiceToText,
  },

  setup() {
    const generalStore = useGeneralStore();
    const mainStore = useMainStore();

    const journeyName = ref(undefined as string | undefined);

    function submitJourney() {
      if (!journeyName.value) return;
      generalStore.journeyName = journeyName.value;
      JourneyService.registerJourney().then((response) => {
        if (response.success) {
          journeyName.value = undefined;
          NotificationService.notifySuccess();
        } else {
          NotificationService.notifyFailure();
        }
      }).catch(() => {
        NotificationService.notifyFailure();
      });
    }

    return {
      generalStore,
      mainStore,
      journeyName,
      submitJourney,
    };
  },
});
